import store from "@/store";
import { getSystemTimestamp } from "@/api/system";

export const dateCalibration = (date, format) => {
  if (!/^[0-9]{13}$/.test(String(date))) throw new Error("签名时间戳无效，请重试");
  // 当前协议的上海时间为 UTC+8，使用 UTC getter 避免设备时区、Intl 实现差异。
  const D = new Date(+date + 8 * 60 * 60 * 1000);
  return format === "day" ? D.getUTCDay() : D.getUTCMonth();
};

export const serverDate = async () => {
  if (store.state.date.correctTamp === null) {
    const result = await getSystemTimestamp();
    const correct = +result.data - new Date().getTime();
    store.dispatch("date/setCorrectTamp", correct);
  }
  const D = new Date();
  const tamp = D.getTime() + store.state.date.correctTamp;
  return tamp;
};
